(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusAssessControllers')
        .directive('actionPlanCriteriaAssessment', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                criteriaAssessment: '=',
                actionPlanUpdateStatusAssessment: '=',
                recomBusinessUnit: '='
                // readOnly: '@'
            },
            restrict: 'AE',
            templateUrl: require('./criteriaAssessment.tpl.html'),
            controller: ['$scope', '$state', '$stateParams', '$timeout', 'recomActionPlanUpdateStatusService', 'grcActionPlanCriteriaService', 'followUpService',
                function ($scope, $state, $stateParams, $timeout, recomActionPlanUpdateStatusService, grcActionPlanCriteriaService, followUpService) {

                    $scope.date = new Date();
                    $scope.date.setHours(0, 0, 0, 0);

                    // Select Status
                    $scope.selectStatus = function (status) {
                        if ($scope.attr.isReadOnly) return;

                        $scope.criteriaAssessment.AssessmentCompletionStatus = status;
                        $scope.criteriaAssessment.AssessmentCompletionStatusID = status.LookupAttributeValueID;

                        if (isInProgress()) {
                            $scope.attr.isInProgress = true;
                        } else if (isCompleted()) {
                            $scope.attr.isCompleted = true;
                        }

                        if (_.isUndefined($scope.criteriaAssessment.AssessmentTargetDate)) {
                            $scope.criteriaAssessment.AssessmentTargetDate = $scope.criteriaAssessment.ActionPlanCriteria.TargetDate;
                        }

                        $scope.setDirty();
                    };

                    // Save Assessment
                    $scope.saveAssessment = function () {
                        if ($scope.forceChangeTargetDate() === true) return;

                        $scope.attr.isSubmitted = true;

                        // Form Invalid
                        if (!$scope.attr.isFormValid) {
                            $scope.attr.isFormInvalidError = true;
                            $timeout(function () {
                                $scope.attr.isFormInvalidError = false;
                            }, 3000);

                            // Require Follow-ups
                            if (areFollowUpsRequired()) {
                                $scope.attr.showRequireFollowUpError = true;
                                $timeout(function () {
                                    $scope.attr.showRequireFollowUpError = false;
                                }, 12500);
                            }

                            return;
                        }

                        $scope.attr.isLoading = true;
                        var requestDone = false,
                            timeoutDone = false;
                        $timeout(function () {
                            if (requestDone) {
                                $scope.attr.isLoading = false;
                            } else {
                                timeoutDone = true;
                            }
                        }, 250);

                        recomActionPlanUpdateStatusService
                            .assessActionPlanCriteria(
                                $stateParams.ItemPersonID, $scope.criteriaAssessment.ActionPlanID,
                                $scope.criteriaAssessment.ActionPlanCriteriaID, $scope.criteriaAssessment)
                            .then(function (criteriaAssessment) {
                                $scope.criteriaAssessment = criteriaAssessment;
                                $scope.attr.isShowSubmitted = $scope.criteriaAssessment.IsSubmitted;

                                return recomActionPlanUpdateStatusService
                                    .getAssessmentsByAssessorAndActionPlan($scope.recomBusinessUnit.RecomBusinessUnitID,
                                        $stateParams.ItemPersonID,
                                        $scope.criteriaAssessment.ActionPlanID)
                                    .then(function (assmntByInitiative) {
                                        $scope.actionPlanUpdateStatusAssessment.ActionPlanAssessment = assmntByInitiative.ActionPlanAssessment;

                                        if (timeoutDone) {
                                            $scope.attr.isLoading = false;
                                        } else {
                                            requestDone = true;
                                        }
                                    });

                            });
                    };

                    // Reset Assessment
                    $scope.resetAssessment = function () {
                        if ($scope.attr.isReadOnly) return;

                        $scope.attr.isLoading = true;
                        recomActionPlanUpdateStatusService
                            .resetActionPlanCriteriaAssessment(
                                $stateParams.ItemPersonID, $scope.criteriaAssessment.ActionPlanID,
                                $scope.criteriaAssessment.ActionPlanCriteriaID, $scope.criteriaAssessment)
                            .then(function (resettedAssessment) {
                                $scope.criteriaAssessment = resettedAssessment;

                                return recomActionPlanUpdateStatusService
                                    .getAssessmentsByAssessorAndActionPlan($scope.recomBusinessUnit.RecomBusinessUnitID, $stateParams.ItemPersonID, $scope.criteriaAssessment.ActionPlanID)
                                    .then(function (assmntByInitiative) {
                                        $scope.actionPlanUpdateStatusAssessment.ActionPlanAssessment = assmntByInitiative.ActionPlanAssessment;

                                        $scope.init();
                                    });
                            }
                            );
                    };

                    // Edit Assessment
                    $scope.editAssessment = function () {
                        $scope.attr.isShowSubmitted = false;
                    };

                    // Set Dirty
                    $scope.setDirty = function () {
                        if ($scope.criteriaAssessment.AssessmentCompletionStatusID) {
                            // Check if there are required fields and if they are provided
                            $scope.attr.isFormValid = areAllFieldsValid();
                        } else {
                            $scope.attr.isShowActions = false;
                        }
                    };

                    // Completion Percentage Changed
                    $scope.completionPercentageChanged = function () {
                        if ($scope.attr.completionPercentage > 0) {
                            $scope.attr.isCompletionPercentageValid = true;
                            $scope.criteriaAssessment.AssessmentCompletionPercentage = $scope.attr.completionPercentage;
                        } else {
                            $scope.attr.isCompletionPercentageValid = false;
                            $scope.criteriaAssessment.AssessmentCompletionPercentage = null;
                        }
                        $scope.setDirty();
                    };

                    // Get Plan Lookups
                    $scope.getPlanLookups = function () {
                        recomActionPlanUpdateStatusService
                            .getActionPlanUpdateStatusLookups()
                            .then(function (planLookups) {
                                $scope.planLookups = planLookups;
                            });
                    };

                    // Is Status Completed?
                    $scope.isStatusCompleted = isCompleted;

                    // Init
                    $scope.init = function () {

                        grcActionPlanCriteriaService
                            .getFollowUpListByActionPlanCriteria(
                                $scope.criteriaAssessment.ActionPlanID,
                                $scope.criteriaAssessment.ActionPlanCriteriaID)
                            .then(function (criteriaAssContainers) {
                                $scope.criteriaAssContainers = criteriaAssContainers;

                                if (_.size(criteriaAssContainers) > 0) {
                                    $scope.currentFollowUps = criteriaAssContainers[0].FollowUps;
                                }

                                $scope.setDirty();
                            });

                        if (!$scope.criteriaAssessment.AssessmentCompletionPercentage) {
                            $scope.criteriaAssessment.AssessmentCompletionPercentage =
                                $scope.criteriaAssessment.ActionPlanCriteria.CompletionPercentage;
                        }

                        $scope.attr = {
                            isReadOnly: true,
                            isCompleted: isCompleted(),
                            isInProgress: isInProgress(),
                            showDatePicker: false,
                            isLoading: false,
                            isShowActions: false,
                            isFormValid: areAllFieldsValid(),
                            completionPercentage: $scope.criteriaAssessment.AssessmentCompletionPercentage,
                            isCompletionPercentageValid: $scope.criteriaAssessment.AssessmentCompletionPercentage > 0,
                            isSubmitted: false,
                            isFormInvalidError: false,
                            showRequireFollowUpError: false,
                            isShowSubmitted: $scope.criteriaAssessment.IsSubmitted
                        };

                        $scope.attr.isReadOnly = $scope.criteriaAssessment.IsReadOnly || $scope.criteriaAssessment.ActionPlan_IsLocked;
                    };

                    // Download Attachments withing followup modals
                    $scope.getDownloadAttachmentUrl = function (attachmentId, criteriaAssessment) {
                        criteriaAssessment = criteriaAssessment || $scope.criteriaAssessment;

                        return recomActionPlanUpdateStatusService
                            .getDownloadAttachmentUrl(
                                criteriaAssessment.ActionPlanCriteria.RecomBusinessUnitID,
                                criteriaAssessment.ActionPlanID,
                                criteriaAssessment.ActionPlanCriteriaID,
                                criteriaAssessment.ActionPlanCriteriaAssessmentID,
                                attachmentId);
                    };

                    // View Followups
                    $scope.viewFollowUps = function () {
                        var modalScope = followUpService.openFollowUpsModal(null,
                            $scope.criteriaAssessment,
                            $scope.currentFollowUps,
                            $scope.criteriaAssContainers,
                            $scope.getDownloadAttachmentUrl);

                        modalScope.submitFollowUp = function (followUp) {
                            return recomActionPlanUpdateStatusService
                                .createActionPlanCriteriaAssessmentFollowUp($stateParams.ItemPersonID,
                                    $scope.criteriaAssessment.ActionPlanID,
                                    $scope.criteriaAssessment.ActionPlanCriteriaID,
                                    $scope.criteriaAssessment.ActionPlanCriteriaAssessmentID,
                                    followUp)
                                .then(function (assessmentContainer) {
                                    var newFollowUp = assessmentContainer.FollowUps[0];
                                    modalScope.currentFollowUps.unshift(newFollowUp);
                                    $scope.currentFollowUps = modalScope.currentFollowUps;
                                    $scope.setDirty();
                                });
                        };
                    };

                    $scope.forceChangeTargetDate = function () {
                        var assesmentDate = new Date($scope.criteriaAssessment.AssessmentTargetDate);
                        assesmentDate.setHours(0, 0, 0, 0);
                        return !isCompleted() && assesmentDate < $scope.date;
                    };

                    // Status
                    //160, 'Completed',
                    //161, 'No-Issue',
                    //162, 'Issues-Being-Monitored',
                    //163, 'Issues-To-Address',
                    //164, 'NotStarted',
                    // Are FollowUps Required
                    function areFollowUpsRequired() {
                        if ($scope.criteriaAssessment.AssessmentCompletionStatusID === 161) return false; // NoIssue
                        if ($scope.criteriaAssessment.AssessmentCompletionStatusID === 164) return false; // NotStarted

                        var areFollowUpsByAssessorPresent =
                            _.chain($scope.currentFollowUps)
                                .filter({ UserIsAssessor: true })
                                .some(function (followUp) {
                                    if (followUp.Comment) return true;

                                    return _.size(followUp.Attachments) > 0;
                                })
                                .value();

                        return !areFollowUpsByAssessorPresent;
                    }

                    function areAllFieldsValid() {
                        if (!$scope.criteriaAssessment.AssessmentCompletionStatusID) return false;
                        if (areFollowUpsRequired()) return false;
                        if ($scope.forceChangeTargetDate()) return false;
                        var conditions = $scope.criteriaAssessment.AssessmentFieldConditions_ByCompletionStatusID,
                            statusID = $scope.criteriaAssessment.AssessmentCompletionStatusID;

                        if (_.isNumber(statusID)) statusID = statusID.toString();

                        for (var attribute in conditions[statusID]) {
                            if (conditions[statusID].hasOwnProperty(attribute)
                                && conditions[statusID][attribute].required
                                && conditions[statusID][attribute].required === 'true'
                                && !$scope.criteriaAssessment[attribute]) {
                                return false;
                            }
                        }

                        return true;
                    }

                    // Is Field Required?
                    function isFieldRequired(fieldName) {
                        if (_.isUndefined(fieldName)) return false;
                        if (_.isUndefined($scope.criteriaAssessment.AssessmentFieldConditions_ByCompletionStatusID)) return false;

                        var conditionsByCompStatusID = $scope.criteriaAssessment.AssessmentFieldConditions_ByCompletionStatusID;
                        var compStatusID = $scope.criteriaAssessment.AssessmentCompletionStatusID;

                        var fieldConditions = conditionsByCompStatusID[compStatusID][fieldName];
                        if (_.isUndefined(fieldConditions)) return false;

                        return fieldConditions['required'];
                    }

                    function isCompleted() {
                        return $scope.criteriaAssessment.AssessmentCompletionStatus && $scope.criteriaAssessment.AssessmentCompletionStatus.Value === 'Completed';
                    }

                    function isInProgress() {
                        if (!$scope.criteriaAssessment.AssessmentCompletionStatus) return false;

                        return $scope.criteriaAssessment.AssessmentCompletionStatus.Value === 'No-Issue'
                            || $scope.criteriaAssessment.AssessmentCompletionStatus.Value === 'Issues-Being-Monitored'
                            || $scope.criteriaAssessment.AssessmentCompletionStatus.Value === 'Issues-To-Address';
                    }


                }],
            link: function (scope, element, attrs) {
                scope.init();
                scope.getPlanLookups();
            }
        };
    }
})();